/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicBookingCalendarPathParameters } from 'api/actions/get-public-booking-calendar/get-public-booking-calendar-path-parameters';
import { GetPublicBookingCalendarResponse } from 'api/actions/get-public-booking-calendar/get-public-booking-calendar-response';

type GetPublicBookingCalendarQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicBookingCalendar action.
 */
export const getPublicBookingCalendarActionPath = new SweetPath<keyof GetPublicBookingCalendarPathParameters>(
  '/reservations/public/bookings/{token}/calendar.ics',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicBookingCalendar actions.
 */
export default function createGetPublicBookingCalendarAction(axios: AxiosInstance) {
  return function getPublicBookingCalendarAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicBookingCalendarPathParameters;
    query?: GetPublicBookingCalendarQueryParameters;
  }) {
    const path = getPublicBookingCalendarActionPath.insert(parameters);

    return axios.get<GetPublicBookingCalendarResponse, GetPublicBookingCalendarResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
